<template>
  <div>
    <div v-if="loading" class="loading-overlay">
      <div class="bounce-loader">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <!-- <i class="mr-2 icon-home" style="font-size: 24px;"></i> -->
          <h1 class="xxl">
            {{ resource["homePageHeaderText"] }}
          </h1>
        </div>
      </div>
    </div>
     <div class="page-view">
      <div class="container p-0">
        <SolutionsCardWithButton :data="solutionsCardData"/>
        <!-- <div class="container home-page p-0">
          <div class="hp-item">Welcome, {{ currentUser.email }}</div>
          <button class="logout-button" id="logout" @click="logout">Logout</button>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
import AccountService from '@/services/account';
import { mapMutations } from 'vuex';
import { serviceWrapper, serviceConfigs } from '@/services/configs';
import SolutionsCardWithButton from './common/SolutionsCardWithButton/SolutionsCardWithButton';

export default {
  name: 'Home',
  components: {
    SolutionsCardWithButton,
  },

  data() {
    return {
      loading: true,
      showModal: true,
      solutionsCardData: {
        title: 'solutionsCardWithButtonTitle',
        buttonUrl: this.$route.params.lang ? `/${this.$route.params.lang}/pricing` : '/pricing',
        buttonText: 'solutionsCardWithButtonBtnText',
        items: [
          {
            icon: require('@/assets/ourSolutions/video-interview.png'),
            title: 'solutionsCardWithButtonOneTitle',
            description: 'solutionsCardWithButtonOneDesc',
          },
          {
            icon: require('@/assets/ourSolutions/in-person-interview.png'),
            title: 'solutionsCardWithButtonTwoTitle',
            description: 'solutionsCardWithButtonTwoDesc',
          },
          {
            icon: require('@/assets/ourSolutions/ai-question-generator.png'),
            title: 'solutionsCardWithButtonThreeTitle',
            description: 'solutionsCardWithButtonThreeDesc',
          },
          {
            icon: require('@/assets/ourSolutions/bulk-sending.png'),
            title: 'solutionsCardWithButtonFourTitle',
            description: 'solutionsCardWithButtonFourDesc',
          },
          {
            icon: require('@/assets/ourSolutions/speech-to-text.png'),
            title: 'solutionsCardWithButtonFiveTitle',
            description: 'solutionsCardWithButtonFiveDesc',
          },
          {
            icon: require('@/assets/ourSolutions/ai-summary.png'),
            title: 'solutionsCardWithButtonSixTitle',
            description: 'solutionsCardWithButtonSixDesc',
          },
          {
            icon: require('@/assets/ourSolutions/interview-report.png'),
            title: 'solutionsCardWithButtonSevenTitle',
            description: 'solutionsCardWithButtonSevenDesc',
          },
          {
            icon: require('@/assets/ourSolutions/knowledge-base.png'),
            title: 'solutionsCardWithButtonEightTitle',
            description: 'solutionsCardWithButtonEightDesc',
          },
          {
            icon: require('@/assets/ourSolutions/ai-scoring.png'),
            title: 'solutionsCardWithButtonNineTitle',
            description: 'solutionsCardWithButtonNineDesc',
          },
          {
            icon: require('@/assets/ourSolutions/knowledge-base.png'),
            title: 'solutionsCardWithButtonTenTitle',
            description: 'solutionsCardWithButtonTenDesc',
          },
          {
            icon: require('@/assets/ourSolutions/knowledge-base.png'),
            title: 'solutionsCardWithButtonElevenTitle',
            description: 'solutionsCardWithButtonElevenDesc',
          },
          {
            icon: require('@/assets/ourSolutions/interview-scheduling.png'),
            title: 'solutionsCardWithButtonTwelveTitle',
            description: 'solutionsCardWithButtonTwelveDesc',
          },
          {
            icon: require('@/assets/ourSolutions/evaluator-assignment.png'),
            title: 'solutionsCardWithButtonThirteenTitle',
            description: 'solutionsCardWithButtonThirteenDesc',
          },
          {
            icon: require('@/assets/ourSolutions/multilanguage-support.png'),
            title: 'solutionsCardWithButtonFourteenTitle',
            description: 'solutionsCardWithButtonFourteenDesc',
          },
          {
            icon: require('@/assets/ourSolutions/knowledge-base.png'),
            title: 'solutionsCardWithButtonFifteenTitle',
            description: 'solutionsCardWithButtonFifteenDesc',
          },
        ],
      },
    };
  },
  created() {
    const isAuth = AccountService.checkAuth();

    const lang = this.$route.params.lang ? `/${this.$route.params.lang}` : '';

    if (!isAuth) {
      if (window.location.hostname.includes('test')) {
        window.location.replace(`https://test-k8s.interview.co${lang}/company`);
      } else if (window.location.hostname.includes('stage')) {
        window.location.replace(`https://stage-k8s.interview.co${lang}/company`);
      } else {
        window.location.replace(`https://interview.co${lang}/company`);
      }
    } else {
      this.loading = false;
    }
  },

  methods: {
    redirectLogin() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'LoginView', params: { lang } });
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'login_click',
        page_type: 'ana-sayfa',
        site_type: 'interview',
      });
    },
    ...mapMutations(['setNavMenuCloseIcon', 'setResponsiveMenuStatus']),
    logout() {
      serviceWrapper(
        serviceConfigs.account,
        serviceConfigs.account.logOut,
        {},
      )
        .then((response) => {
          if (response.data.body.isSuccess === true) {
            const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

            AccountService.reset2fa();
            // delete token from cookie
            AccountService.deleteToken();
            // redirect to login page
            // window.location.reload();
            this.$router.push({ name: 'LoginView', params: { lang } });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.home-page {
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  background: #fff;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column
}

.container {
  &:has(.solutions-card-with-button) {
    max-width: 1124px!important;
  }
}

.hp-item {
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logout-button {
  padding: 9px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 44px;
  border: 0;
  background: #FF8D06;
  color: #FFF;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  margin-bottom: 16px;

  &:hover {
    opacity: .8
  }
}

.loading-overlay {
  transition: visibility 0s ease-in-out 0.5s, opacity 0.5s ease-in-out;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #FFF;
  z-index: 9999;
}
.bounce-loader {
  transition: all 0.2s;
  margin: -9px 0 0 -35px;
  text-align: center;
  width: 70px;
  left: 50%;
  position: absolute;
  top: 50%;
  z-index: 10000;
}
.bounce-loader .bounce1,
.bounce-loader .bounce2,
.bounce-loader .bounce3 {
  -webkit-animation: 1.4s ease-in-out 0s normal both infinite bouncedelay;
  animation: 1.4s ease-in-out 0s normal both infinite bouncedelay;
  background-color: #CCC;
  border-radius: 100%;
  display: inline-block;
  height: 18px;
  width: 18px;
}
.bounce-loader .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.bounce-loader .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@keyframes bouncedelay {
  to {
    transform: scale(0);
  }
  from {
    transform: scale(1);
  }
};

</style>
